module.exports = __webpack_public_path__ + "img/map.cb1a7c03.svg";